import React, { Component } from "react";
import { Link } from "react-router-dom";

import Navbar from '../components/Navbar.jsx';
import Footer from '../components/Footer.jsx';
import Jumbotron from '../components/Jumbotron.jsx'

class Home extends Component{
  render(){
    return(
      <div>
        <Navbar />
        <Jumbotron title="Mein kleiner DEV Playground" description="Nix muss. Alles kann." />
        <div className="container section-card">
          <div className="page-grid">
            <div className="tile-card">
              <div>
                <h2>Über mich</h2>
                <p>Erfahre mehr über meinen beruflichen Werdegang, meine Interessen und was mich antreibt.</p>
              </div>
              <Link to="/about">Zur About-Seite →</Link>
            </div>

            <div className="tile-card">
              <div>
                <h2>Projekte</h2>
                <p>Entdecke meine aktuellen Projekte, Ideen und technischen Experimente.</p>
              </div>
              <Link to="/projects">Zu den Projekten →</Link>
            </div>

            <div className="tile-card">
              <div>
                <h2>Legal & Datenschutz</h2>
                <p>Finde Impressum und Datenschutzerklärung in einer klar strukturierten Darstellung.</p>
              </div>
              <Link to="/impressum">Zum Impressum →</Link>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  };
}

export default Home;
